import { useMutation } from "@tanstack/react-query";
import { BodyOf } from "../../core/api";
import useApi from "../../shared/hooks/useApi";

export function useAiOmnibarPlanMutation() {
  const { api } = useApi();

  return useMutation({
    mutationFn: (body: BodyOf<"post", "./ai_omnibar/plan">) =>
      api.post("./ai_omnibar/plan", { body }),
  });
}

/**
 * Second pass: searching the open screen's own lists for the words the plan used.
 *
 * Separate from planning on purpose - see AiOmnibarCapabilityParam.options on the server. The lists
 * travel from here because they belong to components mounted in this browser, and for page-specific
 * ones this is the first moment they exist at all.
 */
export function useAiOmnibarValueSearchMutation() {
  const { api } = useApi();

  return useMutation({
    mutationFn: (body: BodyOf<"post", "./ai_omnibar/value_search">) =>
      api.post("./ai_omnibar/value_search", { body }),
  });
}

/**
 * Lays out an advanced report from the tables the report tool is allowed to show.
 *
 * A third call, and a different prompt from planning: planning decides which part of the app to
 * drive, this decides what a report should contain. The tables travel from here because the page
 * fetched them, and `/reports/schema` returns only what this member may report on.
 */
export function useAiOmnibarBuildReportMutation() {
  const { api } = useApi();

  return useMutation({
    mutationFn: (body: BodyOf<"post", "./ai_omnibar/build_report">) =>
      api.post("./ai_omnibar/build_report", { body }),
  });
}
